import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface ITimelineItem {
	itemImage?: IImage;
	itemYear: string;
	itemHeading: string;
	/**
	 * Content
	 * @control richtext
	 */
	itemContent: string;
}

export interface ITimelineProps extends IBaseElementProps {
	timelineItems?: ITimelineItem[];
}

/**
 * Calian Timeline Component
 * @icon image-flip-horizontal
 * @block
 */
const Timeline: React.FC<ITimelineProps> = ({
	id,
	className,
	classNames = [],
	timelineItems,
}) => (
	<div
		id={id}
		className={
			className ||
			cn('calian-timeline container-fluid mw-850px', ...classNames)
		}
	>
		{timelineItems?.map((item, index) => (
			<div key={index} className="calian-timeline__item pb-3 pb-md-6">
				{item.itemImage && (
					<div className="ratio ratio-16x9">
						<Image
							className="timeline-item__image img-fluid  object-fit-cover rounded-5"
							{...item.itemImage}
						/>
					</div>
				)}
				<div className="container-fluid my-3 my-md-6">
					<div className="row">
						<div className="col-12 col-md-3">
							{item.itemYear && (
								<p className="timeline-item__year fs-5 text-mid-grey mb-2 ms-md-3 mt-md-1 mb-md-0 ps-md-1">
									{item.itemYear}
								</p>
							)}
						</div>
						<div className="col-12 col-md-9 ps-md-6">
							{item.itemHeading && (
								<h3 className="timeline-item__title ls-0 mb-2 mb-md-3">
									{item.itemHeading}
								</h3>
							)}
							{item.itemContent && (
								<div
									className="timeline-item__content"
									dangerouslySetInnerHTML={{
										__html: item.itemContent,
									}}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		))}
	</div>
);

export default Timeline;
